// Warehouse routes (under accounting app, separate "warehouse" permission)

// Warehouse requires explicit "warehouse" permission (appadmins bypass)
const meta = { requiresAuth: true, app: "warehouse" };

const routes = [
  {
    path: "/accounting/warehouse",
    name: "WarehouseInventory",
    component: () => import("@/views/warehouse/WarehouseHome.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/journal",
    name: "WarehouseJournal",
    component: () => import("@/views/warehouse/WarehouseHome.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/ledger",
    name: "WarehouseLedger",
    component: () => import("@/views/warehouse/WarehouseHome.vue"),
    meta,
  },
  {
    path: "/accounting/warehouse/par-stock",
    name: "WarehouseParStock",
    component: () => import("@/views/warehouse/WarehouseHome.vue"),
    meta,
  },
];

export default routes;
